import styled from 'styled-components';

export const ContactFormStyles = styled.div`
  background: #FFC228;
  
  padding-bottom: 100px;
  
  &.inModal {
    padding: 0 !important;

      .container {
          padding: 0 !important;
      }
  }
  
  h2 {
    margin-bottom: 24px;
    
    font-weight: 800;
    font-size: 44px;
    line-height: 66px;
    
    text-align: center;
    letter-spacing: 0.02em;
    color: #1B1F2C;
  }
  
  .formWrapper {
    &.active {
      .form {
        opacity: 1;
      }
    }
  }
  
  .form {
    display: grid;
    
    margin: auto;
    max-width: 490px;
    width: 100%;
    padding: 40px;
    box-sizing: border-box;
    opacity: 0;
    transition: 1s linear all;
    border-radius: 2px;

    background: #1B1F2C;
    color: #FFF;
    
    .button {
      width: 100%;
    }
    
    @media (max-width: 600px) {
      padding: 16px;
    }
    
    .error {
      font-size: 11px;
      line-height: 16px;
      margin-top: 4px;
      color: #ff3333;
    }
  }
`;
